<template>
  <div class="shop-page">
    <div class="shop-header">
      <v-container>
        <div class="shop-header-title">Tripshop</div>
        <div class="shop-header-description">
          Unique items from Tripsome
          <br />
          providers
        </div>
      </v-container>
    </div>

    <v-container class="shop-body mt-8">
      <div class="shop-filters"></div>
      <v-row class="products-container">
        <product-card
          v-for="product in products"
          :key="product.id"
          @overlay="toggleOverlay"
          :product="product"
          :user="user"
        ></product-card>
      </v-row>
    </v-container>

    <div v-if="overlay" class="shop-overlay"></div>
  </div>
</template>

<script>
import productCard from './productCard.vue';

export default {
  props: {
    products: {
      type: Array,
      require: true,
    },
    user: {
      type: Object,
      require: false,
    },
  },
  components: { productCard },
  data() {
    return {
      overlay: false,
    };
  },
  methods: {
    toggleOverlay(value) {
      this.overlay = value;
    },
  },
  created() {
    
  },
};
</script>

<style>
.shop-header {
  background: url('https://s3.eu-north-1.amazonaws.com/tripsome.az-public/resources/tripshop-banner.jpg');
  background-size: contain;
  height: 180px;
  display: flex;
  align-items: center;
}
.shop-header-title {
  font-size: 32px;
  font-weight: 600;
  line-height: 40px;
  color: white;
}
.shop-header-description {
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
  color: white;
  padding-top: 12px;
}
.shop-overlay {
  background: #1a1b1eb3;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}
</style>
